// src/services/deduction.js
import { api } from "./api";

/**
 * Balances list (already used)
 * GET getkapatyenelistmd.php?mainuser=...&kapattype=...
 */
export async function fetchKapatBalanceList(mainuser, kapattype) {
  if (!mainuser) throw new Error("mainuser missing");
  if (!kapattype) throw new Error("kapattype missing");

  const res = await api.get("getkapatyenelistmd.php", {
    params: { mainuser, kapattype },
    responseType: "text",
    transformResponse: (r) => r, // keep raw string
  });

  return res.data; // JSON array string
}

/**
 * Dropdown list (Android: getSelectedKapatMd)
 * GET getselectedkapatmd.php?mainuser=...&refresh=1
 * Uses ETag via If-None-Match, like Android.
 */
export async function fetchSelectedKapats(mainuser, { refresh = 1, etag = null } = {}) {
  const req = (useEtag) =>
    api.get("getselectedkapatmd.php", {
      params: { mainuser, refresh },
      headers: useEtag && etag ? { "If-None-Match": etag } : undefined,
      responseType: "text",
      transformResponse: (r) => r,
      validateStatus: (s) => (s >= 200 && s < 300) || s === 304,
    });

  try {
    const res = await req(true);
    return { status: res.status, text: res.data || "", etag: res.headers?.etag || "" };
  } catch {
    const res = await req(false); // ✅ no preflight
    return { status: res.status, text: res.data || "", etag: res.headers?.etag || "" };
  }
}


